import React from "react";
import ProductImages from "components/product/images";
import ProductDetails from "./details";
import ProductModal from "./modal";
import useToggle from "hooks/useToggle";
import { trackSelectItem } from "analytics";
import { useCustomer } from "hooks/useStore";
import clsx from "clsx/lite";
import Link from "components/link";
import getProductUrl from "utils/product-url";

const ProductItem = ({
	product, className = "", showModal = true, callback, index, secureCheckout,
	showViewDetails = true, titleClass = "", priceClass = "", showFromText = true,
	source = null, carouselLayout
}) => {
	const [isModalOpen, toggleModal] = useToggle();
	const customer = useCustomer();

	const { handle, title, variants, variant } = product || {};

	const handleProductClick = (event) => {
		event.stopPropagation();
		trackSelectItem({ ...product, index }, customer, source);
		if (callback) callback();
	};

	const handleToggleModal = (event) => {
		event.preventDefault();
		event.stopPropagation();
		trackSelectItem({ ...product, index }, customer);
		toggleModal();
	};

	return (
		<>
			{showModal &&
				<ProductModal product={product} isOpen={isModalOpen} toggle={toggleModal} secureCheckout={secureCheckout} />}
			<Link
				to={getProductUrl({ handle, variant, variants })}
				onClick={handleProductClick}
				onKeyDown={(e) => e.key === "Enter" && handleProductClick(e)}
				tabIndex={0}
				aria-label={`View ${title}`}
				className={clsx(className, "group/card flex animate-blurIn flex-col gap-2.5")}>
				<ProductImages
					openModal={handleToggleModal}
					showModal={showModal}
					product={product}
					showViewDetails={showViewDetails}
					carouselLayout={carouselLayout}
				/>
				<ProductDetails
					product={product}
					titleClass={titleClass}
					priceClass={priceClass}
					showFromText={showFromText} />
			</Link>
		</>
	);
};


export default ProductItem;